import { MobileWebsite } from "./MobileWebsite";
import { DesktopWebsite } from "./DesktopWebsite";

export function WebsiteLayout() {
	if (window.innerWidth >= 500) {
		return <DesktopWebsite />;
	} else {
		return <MobileWebsite />;
	}
}
